module.exports = __webpack_public_path__ + "img/receipt.7335ccf6.png";